// Automatically generated based off OtpSecret.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport")

package com.lightningkite.lightningserver.auth.proof

import com.lightningkite.UUID
import com.lightningkite.lightningdb.ExperimentalLightningServer
import com.lightningkite.lightningdb.GenerateDataClassPaths
import com.lightningkite.lightningdb.HasId
import com.lightningkite.now
import com.lightningkite.uuid
import kotlinx.datetime.Instant
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.time.Duration
import com.lightningkite.serialization.*
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import com.lightningkite.lightningdb.*
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer
import kotlinx.datetime.*
import com.lightningkite.*

// Contextual types: kotlin.time.Duration
fun prepareOtpSecretFields() {
    val props: Array<SerializableProperty<OtpSecret, *>> = arrayOf(OtpSecret__id, OtpSecret_subjectType, OtpSecret_subjectId, OtpSecret_secretBase32, OtpSecret_label, OtpSecret_issuer, OtpSecret_period, OtpSecret_digits, OtpSecret_algorithm, OtpSecret_establishedAt, OtpSecret_lastUsedAt, OtpSecret_expiresAt, OtpSecret_disabledAt)
    OtpSecret.serializer().properties { props }
}
val <K> DataClassPath<K, OtpSecret>._id: DataClassPath<K, UUID> get() = this[OtpSecret__id]
val <K> DataClassPath<K, OtpSecret>.subjectType: DataClassPath<K, String> get() = this[OtpSecret_subjectType]
val <K> DataClassPath<K, OtpSecret>.subjectId: DataClassPath<K, String> get() = this[OtpSecret_subjectId]
val <K> DataClassPath<K, OtpSecret>.secretBase32: DataClassPath<K, String> get() = this[OtpSecret_secretBase32]
val <K> DataClassPath<K, OtpSecret>.label: DataClassPath<K, String> get() = this[OtpSecret_label]
val <K> DataClassPath<K, OtpSecret>.issuer: DataClassPath<K, String> get() = this[OtpSecret_issuer]
val <K> DataClassPath<K, OtpSecret>.period: DataClassPath<K, Duration> get() = this[OtpSecret_period]
val <K> DataClassPath<K, OtpSecret>.digits: DataClassPath<K, Int> get() = this[OtpSecret_digits]
val <K> DataClassPath<K, OtpSecret>.algorithm: DataClassPath<K, OtpHashAlgorithm> get() = this[OtpSecret_algorithm]
val <K> DataClassPath<K, OtpSecret>.establishedAt: DataClassPath<K, Instant> get() = this[OtpSecret_establishedAt]
val <K> DataClassPath<K, OtpSecret>.lastUsedAt: DataClassPath<K, Instant?> get() = this[OtpSecret_lastUsedAt]
val <K> DataClassPath<K, OtpSecret>.expiresAt: DataClassPath<K, Instant?> get() = this[OtpSecret_expiresAt]
val <K> DataClassPath<K, OtpSecret>.disabledAt: DataClassPath<K, Instant?> get() = this[OtpSecret_disabledAt]
inline val OtpSecret.Companion.path: DataClassPath<OtpSecret, OtpSecret> get() = path<OtpSecret>()


object OtpSecret__id: SerializableProperty<OtpSecret, UUID> {
    override val name: String = "_id"
    override fun get(receiver: OtpSecret): UUID = receiver._id
    override fun setCopy(receiver: OtpSecret, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> = UUID.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("_id")
    override val default: UUID = uuid()
}
object OtpSecret_subjectType: SerializableProperty<OtpSecret, String> {
    override val name: String = "subjectType"
    override fun get(receiver: OtpSecret): String = receiver.subjectType
    override fun setCopy(receiver: OtpSecret, value: String) = receiver.copy(subjectType = value)
    override val serializer: KSerializer<String> = String.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("subjectType")
}
object OtpSecret_subjectId: SerializableProperty<OtpSecret, String> {
    override val name: String = "subjectId"
    override fun get(receiver: OtpSecret): String = receiver.subjectId
    override fun setCopy(receiver: OtpSecret, value: String) = receiver.copy(subjectId = value)
    override val serializer: KSerializer<String> = String.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("subjectId")
}
object OtpSecret_secretBase32: SerializableProperty<OtpSecret, String> {
    override val name: String = "secretBase32"
    override fun get(receiver: OtpSecret): String = receiver.secretBase32
    override fun setCopy(receiver: OtpSecret, value: String) = receiver.copy(secretBase32 = value)
    override val serializer: KSerializer<String> = String.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("secretBase32")
}
object OtpSecret_label: SerializableProperty<OtpSecret, String> {
    override val name: String = "label"
    override fun get(receiver: OtpSecret): String = receiver.label
    override fun setCopy(receiver: OtpSecret, value: String) = receiver.copy(label = value)
    override val serializer: KSerializer<String> = String.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("label")
}
object OtpSecret_issuer: SerializableProperty<OtpSecret, String> {
    override val name: String = "issuer"
    override fun get(receiver: OtpSecret): String = receiver.issuer
    override fun setCopy(receiver: OtpSecret, value: String) = receiver.copy(issuer = value)
    override val serializer: KSerializer<String> = String.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("issuer")
}
object OtpSecret_period: SerializableProperty<OtpSecret, Duration> {
    override val name: String = "period"
    override fun get(receiver: OtpSecret): Duration = receiver.period
    override fun setCopy(receiver: OtpSecret, value: Duration) = receiver.copy(period = value)
    override val serializer: KSerializer<Duration> = ContextualSerializer(Duration::class)
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("period")
}
object OtpSecret_digits: SerializableProperty<OtpSecret, Int> {
    override val name: String = "digits"
    override fun get(receiver: OtpSecret): Int = receiver.digits
    override fun setCopy(receiver: OtpSecret, value: Int) = receiver.copy(digits = value)
    override val serializer: KSerializer<Int> = Int.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("digits")
}
object OtpSecret_algorithm: SerializableProperty<OtpSecret, OtpHashAlgorithm> {
    override val name: String = "algorithm"
    override fun get(receiver: OtpSecret): OtpHashAlgorithm = receiver.algorithm
    override fun setCopy(receiver: OtpSecret, value: OtpHashAlgorithm) = receiver.copy(algorithm = value)
    override val serializer: KSerializer<OtpHashAlgorithm> = OtpHashAlgorithm.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("algorithm")
}
object OtpSecret_establishedAt: SerializableProperty<OtpSecret, Instant> {
    override val name: String = "establishedAt"
    override fun get(receiver: OtpSecret): Instant = receiver.establishedAt
    override fun setCopy(receiver: OtpSecret, value: Instant) = receiver.copy(establishedAt = value)
    override val serializer: KSerializer<Instant> = Instant.serializer()
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("establishedAt")
    override val default: Instant = now()
}
object OtpSecret_lastUsedAt: SerializableProperty<OtpSecret, Instant?> {
    override val name: String = "lastUsedAt"
    override fun get(receiver: OtpSecret): Instant? = receiver.lastUsedAt
    override fun setCopy(receiver: OtpSecret, value: Instant?) = receiver.copy(lastUsedAt = value)
    override val serializer: KSerializer<Instant?> = Instant.serializer().nullable2
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("lastUsedAt")
    override val default: Instant? = null
}
object OtpSecret_expiresAt: SerializableProperty<OtpSecret, Instant?> {
    override val name: String = "expiresAt"
    override fun get(receiver: OtpSecret): Instant? = receiver.expiresAt
    override fun setCopy(receiver: OtpSecret, value: Instant?) = receiver.copy(expiresAt = value)
    override val serializer: KSerializer<Instant?> = Instant.serializer().nullable2
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("expiresAt")
    override val default: Instant? = null
}
object OtpSecret_disabledAt: SerializableProperty<OtpSecret, Instant?> {
    override val name: String = "disabledAt"
    override fun get(receiver: OtpSecret): Instant? = receiver.disabledAt
    override fun setCopy(receiver: OtpSecret, value: Instant?) = receiver.copy(disabledAt = value)
    override val serializer: KSerializer<Instant?> = Instant.serializer().nullable2
    override val annotations: List<Annotation> = OtpSecret.serializer().tryFindAnnotations("disabledAt")
    override val default: Instant? = null
}
